import { Component, OnInit, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy, OnDestroy, NgZone, Input } from '@angular/core';
import { ActionSheetController, AlertController, IonContent, ModalController, NavController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Router } from '@angular/router';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { AuftragHelper } from 'src/app/api/helper/auftrag-helper';
import { Auftragsstatus } from 'src/app/api/model/aufteagsstatus';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { File } from '@awesome-cordova-plugins/file/ngx';

// https://stackoverflow.com/questions/38080654/ionic-2-angular-2-images-prepended-with-unsafe-therefore-not-displaying-ev
import { DomSanitizer } from '@angular/platform-browser';
import { MyApp } from 'src/app/api/helper/app';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FileHelper } from 'src/app/api/helper/file-helper';
import { WorkflowStatus, AuftragsKomponente, Adresse, ReCoMobilBild, Auftragstyp, NVE } from 'src/app/api/model/swagger-model';
import { AppConfig } from 'src/app/api/helper/app.config';
import { ClickHelper } from 'src/app/api/helper/click-helper';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { SystemService } from 'src/app/api/system.service';
import { AuftragEx, AuftragListItem, AuftragspositionEx, Barcode, PushMessageType } from 'src/app/api/model/model';
import { Utils } from 'src/app/api/helper/utils';
import { LieferungComponent } from 'src/app/shared/components/lieferung/lieferung.component';
import { Auftragdetails } from '../auftragdetails.helper';
import { ProgloveService } from 'src/app/api/proglove.service';
import { parseBarcode } from 'src/app/api/helper/gs1-barcode-parser';
import { RemoteService } from 'src/app/api/remote.service';
import { AuftragNVEScannenPage } from '../../auftrag-nve-scannen/auftrag-nve-scannen.page';
import { I18N } from 'src/app/api/helper/i18n';

import moment from 'moment';
import { CameraHelper } from 'src/app/shared/helper/camera-helper';

declare var cordova: any;

const log = new Logger("AuftragdetailsKommissionierungComponent");

@Component({
    selector: 'app-auftragdetails-kommissionierung',
    templateUrl: './auftragdetails-kommissionierung.component.html',
    styleUrls: ['./auftragdetails-kommissionierung.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragdetailsKommissionierungComponent implements OnInit, OnDestroy {

    @ViewChild('content', { static: false }) content: IonContent;
    @ViewChild('appLieferung', { read: LieferungComponent, static: false }) appLieferung: LieferungComponent;

    @Input() auftragdetails: Auftragdetails;

    app = MyApp.current;

    key: string = null;
    auftragsnummer: number = null;
    oberauftrag: AuftragEx;
    abholdatum: string;
    abholdatumClassName: string;
    summeArtikelkosten = 0;
    kameraAktiv = false;
    alertAktiv = false;
    dateienVorhanden = false;
    unterMandant = '';

    verwerteradresseAnzeigen = new BehaviorSubject<boolean>(true);
    erzeugeradresseAnzeigen = new BehaviorSubject<boolean>(true);
    abholadresseAnzeigen = new BehaviorSubject<boolean>(true);
    lieferungAnzeigen = new BehaviorSubject<boolean>(true);
    fotos = new BehaviorSubject<boolean>(true);
    anmerkungen = new BehaviorSubject<boolean>(true);
    navigation = new BehaviorSubject<boolean>(true);
    abholadressAdressNummerAnzeigen = false;
    erzeugerAdressNummerAnzeigen = false;
    verwerterAdressNummerAnzeigen = false;

    anzeigeBild: BildVO = null;

    geladen = false;
    isDestroyed = false;
    isVisible = false;
    initialisiert = false;
    isGedruckt = false;

    isKommissionierung = false;

    unterauftraege: AuftragListItem[] = [];

    subscriptions: Subscription[] = [];

    statuszusatzinfoModal: HTMLIonModalElement;

    vorlesenPositionIndex = 0;

    highlightPosition = new BehaviorSubject<number>(-9999);
    isMuted = false;
    letzteErkennung = 0;
    orginalVolume = 0;
    isModalSichtbar = false;

    proGloveLetzteGescanntePositionNr = 0;
    progloveSeriennummerScanAlert: HTMLIonAlertElement;
    progloveSeriennummerScanPosition: AuftragspositionEx;

    progloveSeriennummerPos: number = 0;
    progloveSeriennummerAnzahl: number = 0;

    testButtonsAnzeigen = false;

    constructor(
        private actionSheetController: ActionSheetController,
        private alertController: AlertController,
        private auftragService: AuftragService,
        private systemService: SystemService,
        private stammdatenService: StammdatenService,
        public domSanitizationService: DomSanitizer,
        private fileOpener: FileOpener,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private nav: NavController,
        private file: File,
        private ngZone: NgZone,
        private modalController: ModalController,
        private remoteService: RemoteService,
        private progloveService: ProgloveService) {

        this.testButtonsAnzeigen = !MyApp.isCordovaAvailable();
    }

    get auftrag() { return this.auftragdetails.auftrag; };
    get workflow() { return this.auftragdetails.workflow; };
    get formularKonfiguration() { return this.auftragdetails.formularKonfiguration; };
    get checklisten() { return this.auftragdetails.checklisten; };
    get auftragsbilder() { return this.auftragdetails.auftragsbilder; };
    get bilder() { return this.auftragdetails.bilder; };
    get buttons() { return this.auftragdetails.buttons; };
    get buttons2() { return this.auftragdetails.buttons2; };
    get buttons3() { return this.auftragdetails.buttons3; };

    async ngOnInit() {
        log?.debug('ngOnInit');

        try {
            this.isKommissionierung = true;

            if (this.isKommissionierung && !this.auftrag.OberAuftragKey) {
                this.unterauftraege = await this.auftragService.getUnterauftragListItems(this.auftrag.Key);

                // this.unterauftraege.sort((a, b) => a.Reihenfolge - b.Reihenfolge);
            }

            if (this.auftrag.OberAuftragKey) {
                this.oberauftrag = await this.auftragService.getAuftrag(this.auftrag.OberAuftragKey);
            }

            this.auftragsnummer = this.auftrag.Auftragsnummer;

            this.verwerteradresseAnzeigen.next(this.workflow.einstellungen.VerwerteradresseAnzeigen !== 'nein');
            this.erzeugeradresseAnzeigen.next(this.workflow.einstellungen.ErzeugeradresseAnzeigen !== 'nein');
            this.abholadresseAnzeigen.next(this.workflow.einstellungen.AbholadresseAnzeigen !== 'nein');
            this.lieferungAnzeigen.next(this.workflow.einstellungen.LieferungAnzeigen !== 'nein');
            this.fotos.next(this.workflow.einstellungen.Fotos !== 'nein');
            this.anmerkungen.next(this.workflow.einstellungen.Anmerkungen !== 'nein');

            if (this.isKommissionierung && !this.auftrag.OberAuftragKey) {
                this.lieferungAnzeigen.next(false);
            }

            const abholadresseKomponente = this.formularKonfiguration.komponenten.find(p => p.name === 'Abholadresse');
            const erzeugeradresseKomponente = this.formularKonfiguration.komponenten.find(p => p.name === 'Erzeugeradresse');
            const verwerteradresseKomponente = this.formularKonfiguration.komponenten.find(p => p.name === 'Verwerteradresse');

            this.abholadressAdressNummerAnzeigen = this.getEinstellung(abholadresseKomponente, 'Nummer', 'nein') === 'ja';
            this.erzeugerAdressNummerAnzeigen = this.getEinstellung(erzeugeradresseKomponente, 'Nummer', 'nein') === 'ja';
            this.verwerterAdressNummerAnzeigen = this.getEinstellung(verwerteradresseKomponente, 'Nummer', 'nein') === 'ja';

            this.navigation.next(this.workflow.einstellungen.Navigation !== 'nein');

            this.dateienVorhanden = this.auftrag.Anlagen && this.auftrag.Anlagen.length > 0;

            this.auftragdetails.init();


            this.abholdatum = AuftragHelper.getAbholdatumText(this.auftrag);
            this.abholdatumClassName = AuftragHelper.getAbholdatumClassName(this.auftrag);

            this.vorlesenPositionIndex = 0;

            this.geladen = true;

            this.subscriptions.push(this.auftragService.auftragGeaendert.subscribe((geanderterAuftrag) => {
                if (this.unterauftraege && this.unterauftraege.length) {
                    const index = this.unterauftraege.findIndex(p => p.Key === geanderterAuftrag.Key);

                    if (index >= 0) {
                        this.unterauftraege[index] = this.auftragService.getAuftragListItem(geanderterAuftrag.Key);
                        this.detectChanges('auftragGeaendert');
                    }
                }
            }));

            this.unterMandant = '';

            if (this.auftrag.UnterMandant) {
                if (AppConfig.current.UnterMandant) {
                    if (this.auftrag.UnterMandant.trim().toUpperCase() !== AppConfig.current.UnterMandant.trim().toUpperCase()) {
                        // Es handelt sich um einen Auftrag von einem anderen Untermandanten als das Gerät zugeordnet ist
                        this.unterMandant = this.auftrag.UnterMandant;
                    }
                }
            }

            // if (this.auftrag.Auftragstyp == Auftragstyp.Transportauftrag) {
            //     if (AppConfig.current.einstellungen.TransportauftragFahrzeugKennzeichenPruefen == 'oeffnen') {
            //         // Prüfe ob das Kennzeichen zum angemeldeten Fahrzeug passt
            //         if (this.auftrag.FahrzeugKennung) {
            //             const fahrzeugKennzeichen = Utils.trimToEmpty(App.current.getFahrzeugKennzeichen());

            //             if (fahrzeugKennzeichen) {
            //                 if (fahrzeugKennzeichen != this.auftrag.FahrzeugKennung) {
            //                     UiHelper.showAlert(`Auftrag ist geplant für Fahrzeug \n${this.auftrag.FahrzeugKennung}.\nTour wurde mit Fahrzeug \n${fahrzeugKennzeichen} \ngestartet.`, 'Achtung');
            //                 }
            //             }
            //         }
            //     }
            // }

            this.auftragdetails.updatePositionen();

            if (this.auftrag.OberAuftragKey) {
                this.subscriptions.push(this.progloveService.barcodeReceived.subscribe((barcode) => {
                    this.verarbeiteBarcodeVonProGlove(barcode);
                }));
            }

            this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(info => { this.detectChanges(info); }));

            setTimeout(() => {
                this.starteAuftragAufProGlove();
            }, 100);

            this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(info => this.detectChanges(info)));
            this.subscriptions.push(this.auftragdetails.auftragAbgeschlossen.subscribe(() => this.goBack()));
            this.subscriptions.push(this.auftragdetails.lieferungAnzeigen.subscribe(() => this.lieferungAendern()));
            this.subscriptions.push(this.auftragdetails.druckenAnzeigen.subscribe(workflowStatus => this.auftragdetails.anzeigenDrucken(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.bezahlenAnzeigen.subscribe(workflowStatus => this.auftragdetails.anzeigenBezahlen(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.weiterleitenAnzeigen.subscribe(workflowStatus => this.auftragdetails.anzeigenWeiterleiten(workflowStatus)));
            this.subscriptions.push(this.auftragdetails.scrollToButtons.subscribe(() => this.scrollToButtons()));
            this.subscriptions.push(this.auftragdetails.anmerkungenAnzeigen.subscribe(() => this.auftragdetails.anzeigenAnmerkungen()));
            this.subscriptions.push(this.auftragdetails.auftragspositionFertigChanged.subscribe((position) => this.onAuftragspositionFertigChanged(position)));

            this.detectChanges('ngOnInit');

            this.initialisiert = true;
        } catch (err) {
            log.error('ngOnInit', err);
        }
    }

    detectChanges(info: string) {
        if (!this.isDestroyed) {
            log?.debug('detectChanges: ' + info);
            this.cdr.detectChanges();
        }
    }

    ngOnDestroy() {
        log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        this.entferneAuftragVonProGlove();

        this.isDestroyed = true;
    }

    async ionViewWillEnter() {
        log?.debug('ionViewWillEnter');
    }

    async ionViewDidEnter() {
        log?.debug('ionViewDidEnter');
        this.isVisible = true;
        this.isMuted = false;

        MyApp.current.backAction = () => this.goBack();

        let ttl = 20;

        while (!this.auftrag) {
            await MyApp.delay(100);

            if (ttl-- < 0) {
                break;
            }
        }

        this.auftragService.setzeAktivenAuftrag(this.auftrag, 'auftragdetails');

        if (this.appLieferung) {
            this.appLieferung.refresh();
        }

        this.detectChanges('ionViewDidEnter');
    }

    ionViewWillLeave() {
        this.isVisible = false;

        MyApp.current.backAction = null;
        this.auftragService.setzeAktivenAuftrag(null, 'auftragdetails exit');
    }

    async goBack() {
        log?.debug('goBack');

        if (this.anzeigeBild) {
            log?.debug('goBack abbruch wegen anzeigeBild');
            this.anzeigeBild = null;
            return;
        }

        if (this.alertAktiv) {
            log?.debug('goBack abbruch wegen alertAktiv');
            // ignoriere Hardware-Back-Button
            return;
        }

        if (this.kameraAktiv) {
            log?.debug('goBack abbruch wegen kameraAktiv');
            // ignoriere Hardware-Back-Button
            return;
        }

        if (this.auftrag) {
            if (this.auftrag.OberAuftragKey) {
                await this.nav.navigateBack('/auftragsliste/details/' + this.auftrag.OberAuftragKey);
            } else {
                await this.nav.navigateBack('/auftragsliste/aktuell/' + this.auftrag.Auftragstyp);
            }
        } else {
            await this.nav.navigateRoot('/');
        }
    }

    async statusMelden(status: WorkflowStatus, mitRueckfrage: boolean): Promise<void> {
        await this.auftragdetails.statusMelden(status, mitRueckfrage);
    }

    scrollToButtons() {
        const formularKonfiguration = this.formularKonfiguration;

        // Nur nach unten scrollen, wenn die Buttons ganz unten angezeigt werden
        if (formularKonfiguration && formularKonfiguration.komponenten && formularKonfiguration.komponenten.length) {
            const letzteKomponente = formularKonfiguration.komponenten[formularKonfiguration.komponenten.length - 1];

            if (letzteKomponente.name == 'Buttons') {
                setTimeout(() => {
                    if (this.content) {
                        this.content.scrollToBottom(300)
                    }
                }, 250);
            }
        }
    }

    async onAnrufen(adresse: Adresse) {
        this.auftragdetails.anrufen(adresse);
    }

    async onNavigationStarten(adresse: Adresse) {
        log?.debug('onNavigationStarten');
        this.auftragdetails.starteNavigation(adresse);
    }

    // async onOptionenAnzeigen() {
    //     const that = this;

    //     const buttons: ActionSheetButton[] = [];

    //     if (this.navigation.getValue()) {
    //         buttons.push({
    //             text: 'Navigation zu Einsatzort',
    //             role: 'destructive',
    //             icon: 'navigate',
    //             handler: () => {
    //                 this.auftragdetails.starteNavigation(this.auftrag.Abholadresse);
    //             }
    //         });
    //     }

    //     if (this.fotos.getValue() && !this.istAuftragAbgeschlossen) {
    //         buttons.push({
    //             text: 'Foto aufnehmen',
    //             icon: 'camera',
    //             handler: () => {
    //                 that.onFotoAufnehmen();
    //             }
    //         });
    //     }

    //     if (this.lieferungAnzeigen.getValue() && !this.istAuftragAbgeschlossen) {
    //         buttons.push({
    //             text: 'Lieferung ändern',
    //             icon: 'basket',
    //             handler: () => {
    //                 that.lieferungAendern();
    //             }
    //         });
    //     }

    //     if (AppConfig.current.einstellungen.AuftragBarcodeButtonVerfuegbar === 'ja') {
    //         buttons.push({
    //             text: 'Barcode anzeigen',
    //             icon: 'barcode',
    //             handler: () => {
    //                 this.auftragdetails.anzeigenBarcode();
    //             }
    //         });
    //     }

    //     buttons.push({
    //         text: 'Abbruch',
    //         icon: 'close',
    //         role: 'cancel',
    //         handler: () => {
    //             log?.debug('Cancel clicked');
    //         }
    //     });

    //     const actionSheet = await this.actionSheetController.create({
    //         header: 'Mehr',
    //         buttons
    //     });

    //     await actionSheet.present();
    // }

    istAuftragZugewiesen(unterauftrag: AuftragListItem) {
        return unterauftrag.Auftragsstatus >= Auftragsstatus.Zugewiesen
            && unterauftrag.Geraet === AppConfig.current.geraeteNummer;
    }

    async onLieferungClicked(e: TouchEvent) {
        log?.debug('onLieferungClicked', e);

        if (e.target) {
            const element = e.target as HTMLElement;

            if (element.tagName && element.tagName.toUpperCase() == "ION-BUTTON") {
                // Ignorieren. Es wurde auf einen Plus/Minus-Button geklickt
                return;
            }
        }

        this.lieferungAendern();
    }

    private lieferungAendern() {
        this.auftragdetails.lieferungAendern();
    }

    async onFotoAufnehmenClicked(e: Event) {
        ClickHelper.click(e, () => this.onFotoAufnehmen());
    }

    async onFotoAufnehmen() {
        if (this.auftragdetails.isBilderErfassenGesperrt) {
            UiHelper.showAlert('Auftrag ist schreibgeschützt. Änderungen sind nicht möglich.');
            return;
        }

        this.kameraAktiv = true;

        let pictureSrc = await CameraHelper.takePicture({
            filenamePrefix: 'auftrag-' + this.auftrag.Auftragsnummer,
        });

        if (!pictureSrc) {
            setTimeout(() => {
                this.kameraAktiv = false;
            }, 250);

            return;
        }

        log?.debug('pictureSrc', pictureSrc);

        const bild: ReCoMobilBild = {
            Datum: new Date().toISOString(),
            // Bild: imageData,
            BildGuid: Utils.uuid()
        };

        await this.auftragService.speichereBild(bild.BildGuid, pictureSrc);

        if (!this.auftrag.Auftragsbilder) {
            this.auftrag.Auftragsbilder = [];
        }

        this.auftrag.Auftragsbilder.push(bild);

        await this.auftragService.speichereAuftrag(this.auftrag);

        this.auftragsbilder.push(await this.auftragdetails.createBildVo(bild));

        this.detectChanges('onFotoAufnehmen');

        setTimeout(() => {
            this.kameraAktiv = false;
        }, 250);

        // setTimeout(() => this.content.scrollToBottom(300), 250);
    }

    async onBildClicked(vo: BildVO) {
        this.anzeigeBild = vo;
    }

    async doBildAnzeigen(vo: BildVO) {
        const filePath = await this.auftragService.getBildSrc(vo.guid);
        await this.fileOpener.open(filePath, 'image/jpeg');
    }

    showAuftragsbild(p: BildVO) {
        this.router.navigateByUrl('/auftragsliste/details/' + this.auftrag.Key + '/bild/' + p.nummer);
    }

    onAnmerkungenBearbeiten() {
        if (this.auftragdetails.isAnmerkungenErfassenGesperrt) {
            return;
        }

        this.router.navigateByUrl('/auftragsliste/details/' + this.auftrag.Key + '/anmerkungen');
    }

    async anzeigenBarcode() {
        this.auftragdetails.anzeigenBarcode();
    }

    getEinstellung(komponente: AuftragsKomponente, key: string, defaultValue: string): string {
        return this.auftragdetails.getEinstellung(komponente, key, defaultValue);
    }

    getStyle(komponente: AuftragsKomponente): string {
        return this.auftragdetails.getStyle(komponente);
    }

    istStatusuebergangErlaubt(workflowStatus: WorkflowStatus) {
        if (!this.auftrag) {
            return false;
        }

        if (!workflowStatus) {
            return true;
        }

        return this.auftragService.istStatusuebergangErlaubt(this.auftrag, this.workflow, workflowStatus);
    }

    getTitel(): string {
        if (this.auftrag) {
            if (this.auftrag.Auftragstyp == Auftragstyp.Kommissionierung) {
                if (this.auftrag.OberAuftragKey) {
                    return 'Palette ' + this.auftrag.label;
                } else {
                    return 'Tour ' + this.auftragsnummer;
                }
            }
        }

        let text = 'Auftrag ' + this.auftragsnummer;

        if (this.unterMandant) {
            text += ', ' + this.unterMandant;
        }

        return text;
    }

    getUnterauftragIcon(unterauftrag: AuftragListItem): string {
        switch (unterauftrag.Auftragsstatus) {
            case Auftragsstatus.Unbekannt:
            case Auftragsstatus.Neu:
                return 'help';
            case Auftragsstatus.Zugewiesen:
                return 'pricetag';
            case Auftragsstatus.InBearbeitung:
                return 'play';
            case Auftragsstatus.Unterbrochen:
                return 'pause';
            case Auftragsstatus.Abgeschlossen:
                return 'checkmark';
            case Auftragsstatus.Abgelehnt:
                return 'hand';
            case Auftragsstatus.Geloescht:
                return 'close';
            default:
                return 'help';
        }
    }

    getUnterauftragClassName(unterauftrag: AuftragListItem): string {
        return 'auftragsstatus-' + unterauftrag.Auftragsstatus;
    }

    async starteAuftragAufProGlove() {
        if (!MyApp.current.ProGloveVerfuegbar.getValue()) {
            return;
        }

        if (this.auftrag.Auftragsstatus >= 90) {
            return;
        }

        if (this.auftrag.Auftragstyp === Auftragstyp.Kommissionierung) {
            if (this.auftrag.OberAuftragKey) {
                log?.info('starteAuftragAufProGlove');

                // Es handelt sich um eine Palette
                // Sende die Positionen der Platte an die ProGlove
                const mengeText = AuftragHelper.getMengeText(this.auftrag);

                await this.progloveService.setStandardProfile(true);

                await this.progloveService.displayTemplate(
                    'PG2',
                    `1|Palette|${this.auftrag.Info1}|2|Anzahl|${mengeText}`,
                    '|',
                    5000
                );

                await Utils.delay(4000);

                if (!this.auftrag) {
                    return;
                }

                await this.sendeNaechstePositionAnProGlove();
            }
        }
    }

    async onAuftragspositionFertigChanged(position: AuftragspositionEx) {
        log?.debug('onAuftragspositionFertigChanged: ' + position.Fertig);

        if (position.Fertig) {
            if (this.proGloveLetzteGescanntePositionNr != position.PosNr) {
                // if (this.auftrag.GeraeteGruppe) {
                //     // Auftrag wurde noch nicht dem Gerät zugewiesen.
                //     const listItem = this.auftragService.getAuftragListItem(this.auftrag.Key);

                //     if (listItem) {
                //         const success = await this.auftragdetails.zuweisenAuftrag(listItem, true);

                //         if (!success) {
                //             this.progloveService.triggerFeedback(2);
                //             this.progloveService.displayError('Palette konnte nicht reserviert werden');
                //             return;
                //         }
                //     }
                // }

                // Position wurde manuell abgehakt
                await this.sendeNaechstePositionAnProGlove();
            }
        }
    }

    async sendeNaechstePositionAnProGlove() {
        if (!MyApp.current.ProGloveVerfuegbar.getValue()) {
            return;
        }

        log?.debug('sendeNaechstePositionAnProGlove');

        await this.progloveService.setStandardProfile();

        const position = this.auftrag.Positionen.find(p => !p.Fertig);

        if (!position) {
            await this.progloveService.displayTemplate(
                'PG1A',
                `1|${this.auftrag.Info1}|Fertig`,
                '|',
                0
            );

            if (this.auftrag.Auftragsstatus < Auftragsstatus.Gedruckt && !this.isGedruckt) {
                const druckformularName = AppConfig.current.einstellungen.KommisionierungPaletteDruckWennFertig;

                if (druckformularName) {
                    // Merke, dass der automatische Druck schon angestoßen wurde.
                    // sonst wird bei doppeltem Scannen eventuell mehrfach gedruckt
                    this.isGedruckt = true;

                    this.auftragdetails.drucken(druckformularName);
                }
            }

            return;
        }

        if (position.LPN) {
            await this.progloveService.displayTemplate(
                'PG2',
                `1|Lagerplatz|${position.LPN}|2|Anzahl|${position.Menge} ${position.Einheit}`,
                '|',
                0
            );
        } else {
            await this.progloveService.displayTemplate(
                'PG2',
                `1|Artikel|${position.Bezeichnung}|2|Anzahl|${position.Menge} ${position.Einheit}`,
                '|',
                0
            );
        }
    }

    async entferneAuftragVonProGlove() {
        if (!MyApp.current.ProGloveVerfuegbar.getValue()) {
            return;
        }

        if (this.auftrag.Auftragstyp === Auftragstyp.Kommissionierung) {
            if (this.auftrag.OberAuftragKey) {
                await this.progloveService.displayTemplate(
                    'PG1A',
                    `1||Warte auf Daten`,
                    '|',
                    0
                );
            }
        }
    }

    async onButtonClicked(button: ButtonVO) {
        if (this.auftragdetails.istAuftragAbgeschlossen) {
            let erlaubt = false;

            if (button.workflowStatus) {
                erlaubt = button.workflowStatus.NachAbschlussErlaubt;
            }

            if (!erlaubt) {
                this.auftragdetails.showAuftragArchiviert();
                return;
            }
        }

        if (button.workflowStatus) {
            await this.auftragdetails.statusMelden(button.workflowStatus, true);
        } else {
            this.auftragdetails.onStatusmeldung();
        }
    }

    async onSimuliereBarcode(format: string, text: string) {
        await this.verarbeiteBarcodeVonProGlove({
            format: format,
            text: text,
            source: 'SIMULATION'
        });
    }

    async verarbeiteBarcodeVonProGlove(barcode: Barcode) {
        log?.debug('verarbeiteBarcodeVonProGlove: ' + barcode.text + ', ' + barcode.text);

        if (!this.auftrag) {
            return;
        }

        if (this.progloveSeriennummerScanPosition) {
            // Es wird gerade eine Seriennummer für eine Position gescannt
            await this.verarbeiteSeriennummerBarcodeVonProGlove(barcode);
            return;
        }

        const personalKey = MyApp.current.getPersonalKey();

        let artikelNr = '';
        let charge = '';
        let gtin = '';
        let nveNummer = '';
        let mhd = '';

        let isGS1 = Utils.isGS1Barcode(barcode);

        if (isGS1) {
            // Aufbau ist über das Format eindeutig definiert
            // https://de.wikipedia.org/wiki/GS1-128
            const result = parseBarcode(barcode.text);

            log?.debug('Barcode parse Result', result);

            if (result?.parsedCodeItems) {
                for (const item of result.parsedCodeItems) {
                    const ai = item.ai as string;
                    const raw = item.raw as string;

                    switch (ai) {
                        case '00':
                            // NVE
                            nveNummer = raw;
                            break;

                        case '01':
                            // Global Trade Item Number
                            gtin = raw;
                            break;

                        case '02':
                            // CONTENT
                            // GTIN der Handelseinheiten, enthalten in einer logistischen Einheit
                            gtin = raw;
                            break;

                        case '10':
                            // Losnummer/Chargennummer des Artikels
                            charge = raw;
                            break;

                        // case '10':
                        //     // Herstellungsdatum                            
                        //     break;

                        case '30':
                            // MENGE
                            break;

                        case '37':
                            // MENGE (enthalten in einer logistischen Einheit)
                            break;

                        case '15': {
                            // Mindesthaltbarkeitsdatum 
                            const date = item.data as Date;
                            const datum = moment(date);
                            mhd = datum.format('DD.MM.YYYY');
                            break;
                        }

                        case '17': {
                            // Verfallsdatum
                            const date = item.data as Date;
                            const datum = moment(date);
                            mhd = datum.format('DD.MM.YYYY');
                            break;
                        }
                    }
                }
            }
        } else {
            const regex = AppConfig.current.einstellungen.KommisionierungBarcodeRegEx;
            let isRegexMatch = false;

            if (regex) {
                // Unicode-Zeichen können z.B. mit \x{29} gefunden werden 
                // Beispiel: 0204017300030213374015220310101003211
                const matchResult = barcode.text.match(regex);

                if (matchResult) {
                    isRegexMatch = true;

                    const artikelNrGroupNo = Utils.parseInt(AppConfig.current.einstellungen.KommisionierungBarcodeArtikelNrGroupNumber);
                    const chargeGroupNo = Utils.parseInt(AppConfig.current.einstellungen.KommisionierungBarcodeChargeGroupNumber);
                    const gtinGroupNo = Utils.parseInt(AppConfig.current.einstellungen.KommisionierungBarcodeGTINGroupNumber);
                    const nveGroupNo = Utils.parseInt(AppConfig.current.einstellungen.KommisionierungBarcodeNVEGroupNumber);
                    const mhdGroupNo = Utils.parseInt(AppConfig.current.einstellungen.KommisionierungBarcodeMHDGroupNumber);

                    if (artikelNrGroupNo && artikelNrGroupNo < matchResult.length) {
                        artikelNr = matchResult[artikelNrGroupNo];
                    }

                    if (chargeGroupNo && chargeGroupNo < matchResult.length) {
                        charge = matchResult[chargeGroupNo];
                    }

                    if (gtinGroupNo && gtinGroupNo < matchResult.length) {
                        gtin = matchResult[gtinGroupNo];
                    }

                    if (nveGroupNo && nveGroupNo < matchResult.length) {
                        nveNummer = matchResult[nveGroupNo];
                    }

                    if (mhdGroupNo && mhdGroupNo < matchResult.length) {
                        mhd = matchResult[mhdGroupNo];
                    }
                }
            } else {


                // Ungültiger Barcode
                // ProGlov rot blinken lassen
                //     this.progloveService.triggerFeedback(2);
                //     this.progloveService.displayError('Falscher Barcode');

                //     return;

                // UiHelper.showErrorOhneSentry('Barcode empfangen aber kein RegEx konfiguriert.');

                // this.progloveService.triggerFeedback(2);
                // this.progloveService.displayError('Nicht konfiguriert');

            }

            // if(!isRegexMatch) {
            //     // Unbekannter Barcode. ProGlove orange blinken lassen und Barcode protokollieren
            //     this.progloveService.triggerFeedback(3);
            //     this.progloveService.displayError('OK'); // Ist eigentlich kein "Error"

            //     this.auftrag.Protokoll.push({
            //         Datum: Utils.nowIsoDateString(),
            //         Typ: 'Barcode',
            //         Text: 'Barcode gescannt',
            //         Info1: barcode.text,
            //         Info2: barcode.format
            //     });

            //     await this.auftragService.speichereAuftrag(this.auftrag);

            //     return;
            // }
        }

        log?.info(`Barcode gescannt: ARTIKEL=${artikelNr}, CHARGE=${charge}, GTIN=${gtin}, NVE=${nveNummer}, MHD=${mhd}`);

        // Handelt es sich um den neuen NVE-Ablauf bei Distelhäuser?
        // Also es wurde eine NVE gescannt?
        let nveAblauf = false;
        let nve: NVE = null;

        if (nveNummer && Utils.isTrue(AppConfig.current.einstellungen.KommissionierungChargenverfolgungNVE)) {
            // NVE gescannt.
            MyApp.loading(true);

            const result = await this.remoteService.getNVE({ NVE: nveNummer });

            MyApp.loading(false);

            if (!result) {
                UiHelper.showFehlerKommunikation();
                return;
            }

            if (result.ErrorMessage) {
                UiHelper.showErrorOhneSentry(result.ErrorMessage);
                return;
            }

            if (!result.NVE || !result.NVE.Key) {
                UiHelper.showErrorLight('Unbekannte NVE: ' + nveNummer);
                return;
            }

            nve = result.NVE;

            if (!nve.GTIN) {
                UiHelper.showErrorLight('NVE hat keine GTIN: ' + nveNummer);
                return;
            }

            gtin = nve.GTIN;

            nveAblauf = true;
        }

        if (!artikelNr && !gtin) {
            log.warn('Barcode ohne Artikel und ohne GTIN gelesen. Wird ignoriert: ' + barcode.text);
            // Ignorieren
            // this.progloveService.triggerFeedback(2);
            // this.progloveService.displayError('Keine Artikelnr.');

            this.auftrag.Protokoll.push({
                Datum: Utils.nowIsoDateString(),
                Typ: 'Barcode',
                Text: 'Barcode',
                Info1: barcode.text,
                Info2: barcode.format,
                Info3: '',
                Info4: '',
                Info5: '',
                PersonalKey: personalKey,
                PersonalName: MyApp.current.getPersonalName(),
                Personalnummer: MyApp.current.getPersonalnummer()
            });

            await this.auftragService.speichereAuftrag(this.auftrag);

            this.auftragdetails.detectChanges.next('barcode gescannt');

            return;
        }

        // Suche die Position mit der Artikelnummer
        let position: AuftragspositionEx;

        if (gtin) {
            const gtinVal = parseInt(gtin, 10);

            position = this.auftrag.Positionen.find(p => p.GTIN == gtin && !p.Fertig);

            if (!position && gtinVal > 0) {
                position = this.auftrag.Positionen.find(p => Utils.parseInt(p.GTIN) == gtinVal);
            }

            if (!position) {
                position = this.auftrag.Positionen.find(p => p.GTIN == gtin);
            }
        }

        if (artikelNr && !position) {
            position = this.auftrag.Positionen.find(p => p.ArtikelKey == artikelNr && !p.Fertig);

            if (!position) {
                position = this.auftrag.Positionen.find(p => p.ArtikelKey == artikelNr);
            }
        }

        if (!position) {
            if (barcode.source === 'ZEBRA' || barcode.source === 'SIMULATION') {
                UiHelper.showErrorOhneSentry('Falscher Artikel: ' + gtin);
            } else {
                this.progloveService.triggerFeedback(2);
                this.progloveService.displayError('Artikel falsch');
            }

            // this.auftrag.Protokoll.push({
            //     Datum: Utils.nowIsoDateString(),
            //     Typ: 'Barcode',
            //     Text: 'Barcode (falscher Artikel)',
            //     Info1: barcode.text,
            //     Info2: barcode.format
            // });

            // await this.auftragService.speichereAuftrag(this.auftrag);

            // this.auftragdetails.detectChanges.next('barcode gescannt');

            return;
        }

        if (position.Fertig) {
            this.progloveService.triggerFeedback(3);
            this.progloveService.displayError('Doppelt');

            if (!nveAblauf) {
                return;
            }
        }

        if (this.auftrag.GeraeteGruppe) {
            // Auftrag wurde noch nicht dem Gerät zugewiesen.
            const listItem = this.auftragService.getAuftragListItem(this.auftrag.Key);

            if (listItem) {
                const success = await this.auftragdetails.zuweisenAuftrag(listItem, true);

                if (!success) {
                    this.progloveService.triggerFeedback(2);
                    this.progloveService.displayError('Palette konnte nicht reserviert werden');
                    return;
                }
            }
        }

        this.auftrag.Protokoll.push({
            Datum: Utils.nowIsoDateString(),
            Typ: 'Barcode',
            Text: position.Bezeichnung,
            Info1: barcode.text,
            Info2: barcode.format,
            Info3: charge,
            Info4: mhd,
            Info5: '',
            PersonalKey: personalKey,
            PersonalName: MyApp.current.getPersonalName(),
            Personalnummer: MyApp.current.getPersonalnummer()
        });

        this.progloveService.triggerFeedback(1);

        if (nveAblauf) {
            // Fenster anzeigen in dem die entnommene Menge nochmal bestätigt werden muss
            log?.debug('nveAblauf');

            const modal = await this.modalController.create({
                component: AuftragNVEScannenPage,
                componentProps: {
                    'auftrag': this.auftrag,
                    'auftragdetails': this.auftragdetails,
                    'position': position,
                    'nve': nve
                }
            });

            await modal.present();

            const modalResult = await modal.onDidDismiss();

            if (!modalResult.data.gespeichert) {
                // Abbruch
                return;
            }

            await Utils.delay(250);

            charge = Utils.distinct(position.Chargen.map(p => p.Charge)).join(', ');
            nveNummer = Utils.distinct(position.Chargen.map(p => p.NVE)).join(', ');
            mhd = Utils.distinct(position.Chargen.map(p => p.MHD)).join(', ');
        }

        if (position.SeriennummerErforderlich) {
            // Auffordern Seriennummer zu scannen
            log?.debug('SeriennummerErforderlich für Position: ' + position.Bezeichnung);

            await this.progloveService.setSeriennummerProfile(true);

            this.progloveSeriennummerScanPosition = position;

            let anzahl = 1;

            if (typeof (position.Menge) === 'number') {
                anzahl = position.Menge;
            }

            if (anzahl > 100 || anzahl <= 0) {
                anzahl = 0;
            }

            this.progloveSeriennummerAnzahl = anzahl;

            for (let i = 1; i <= anzahl; i++) {
                this.progloveSeriennummerPos = i;

                try {
                    log?.info(`${position.Bezeichnung}: Seriennummer scannen ${i}/${anzahl}`);

                    await this.progloveService.displayText(`Seriennummer scannen ${i}/${anzahl}`, position.Bezeichnung, 0);

                    if (this.progloveSeriennummerScanAlert) {
                        this.progloveSeriennummerScanAlert.dismiss();
                        this.progloveSeriennummerScanAlert = null;
                    }

                    this.progloveSeriennummerScanAlert = await this.alertController.create({
                        mode: 'ios',
                        message: `Seriennummer scannen ${i}/${anzahl}...`,
                        buttons: [{
                            text: I18N.instant('Abbrechen'),
                            role: 'cancel',
                            cssClass: 'secondary',
                            handler: () => {
                            }
                        },
                        ]
                    });

                    await this.progloveSeriennummerScanAlert.present();

                    if (MyApp.isCordovaAvailable()) {
                        await this.progloveSeriennummerScanAlert.onDidDismiss();
                        this.progloveSeriennummerScanAlert = null;
                    } else {
                        await Utils.delay(2000);

                        log?.debug('onSimuliereBarcode START');

                        await this.onSimuliereBarcode('XX', '000000000' + i);

                        log?.debug('onSimuliereBarcode FERTIG');
                    }
                } catch (err) {
                    log.error('Fehler beim Scannen der Seriennnummer: ' + Utils.getErrorMessage(err));
                    break;
                }
            }
        }

        this.progloveSeriennummerScanPosition = null;

        await this.progloveService.setStandardProfile(true);

        log?.debug(`Position ${position.PosNr} ist fertig`);
        position.Fertig = true;
        // position.NVE = nve;
        // position.Charge = charge;

        if (charge) {
            AuftragHelper.setzeEigenschaft(position, 'Charge', charge);
        }

        if (nveNummer) {
            AuftragHelper.setzeEigenschaft(position, 'NVE', nveNummer);
        }

        if (mhd) {
            AuftragHelper.setzeEigenschaft(position, 'MHD', mhd, 'datum');
        }

        this.proGloveLetzteGescanntePositionNr = position.PosNr;

        await this.auftragService.speichereAuftrag(this.auftrag);

        this.auftragdetails.detectChanges.next('verarbeiteBarcodeVonProGlove');

        await this.sendeNaechstePositionAnProGlove();
    }

    async verarbeiteSeriennummerBarcodeVonProGlove(barcode: Barcode) {
        log?.debug('verarbeiteSeriennummerBarcodeVonProGlove: ' + barcode.text + ', ' + barcode.text);

        const position = this.progloveSeriennummerScanPosition;

        if (!this.auftrag || !position) {
            log.warn('Kein Auftrag oder keine Position');
            return;
        }

        if (barcode.format && barcode.format.startsWith('GS1')) {
            log.warn('Fehler. Seriennummer kann kein GS1 sein !');
            this.progloveService.triggerFeedback(2);
            return;
        }

        this.progloveService.triggerFeedback(1);

        this.auftrag.Protokoll.push({
            Datum: Utils.nowIsoDateString(),
            Typ: 'Seriennummer',
            Text: position.Bezeichnung,
            Info1: barcode.text,
            Info2: barcode.format,
            PersonalKey: MyApp.current.getPersonalKey(),
            PersonalName: MyApp.current.getPersonalName(),
            Personalnummer: MyApp.current.getPersonalnummer()
        });

        // log?.debug(`Position ${position.PosNr} ist fertig`);

        // position.Fertig = true;

        if (this.progloveSeriennummerPos > 1) {
            AuftragHelper.setzeEigenschaft(position, 'Seriennummer ' + this.progloveSeriennummerPos, barcode.text);
        } else {
            AuftragHelper.setzeEigenschaft(position, 'Seriennummer', barcode.text);
        }

        this.proGloveLetzteGescanntePositionNr = position.PosNr;

        // log?.debug('Speichere Auftrag START');

        // await this.auftragService.speichereAuftrag(this.auftrag);

        // log?.debug('Speichere Auftrag ENDE');

        this.auftragdetails.detectChanges.next('verarbeiteBarcodeVonProGlove');

        if (this.progloveSeriennummerScanAlert) {
            this.progloveSeriennummerScanAlert.dismiss();
            this.progloveSeriennummerScanAlert = null;
        }

        // await this.sendeNaechstePositionAnProGlove();
    }
}

interface BildVO {
    src: string;
    datum?: string;
    nummer?: number;
    guid: string;
    bezeichnung: string;
}

interface ButtonVO {
    text: string;
    icon: string;
    color: string;
    workflowStatus: WorkflowStatus;
}


